module.exports = __webpack_public_path__ + "media/images/mail_ic-e3b21222d3e9d594f754582f6bc0da58.svg";